const SYMBOLS = {
  NGN: '₦',
  USD: '$',
  CAD: '$',
  GBP: '£',
  EUR: '€',
};

export function formatCurrency(amount, currency = 'NGN') {
  const symbol = SYMBOLS[currency] || '';
  try {
    // Use Intl if available for better grouping
    const formatted = new Intl.NumberFormat(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(Number(amount || 0));
    return `${symbol}${formatted}`;
  } catch {
    const num = Number(amount || 0)
      .toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `${symbol}${num}`;
  }
}

export function computePromoPercent(price, compareAtPrice) {
  if (!compareAtPrice || !price) return 0;
  const cp = Number(compareAtPrice);
  const p = Number(price);
  if (cp > p) {
    return Math.round(((cp - p) / cp) * 100);
  }
  return 0;
}


